import { L, vocabulary } from '../define.js';
/**
 * D580 — the vocabularies the Admin person record (passenger / driver 360) shows that no domain package exports as a
 * closed list: the operator-side reads `GET /v1/ops/users/:id/{registration,relationships,safety-incidents}` and the contextual
 * safety flag reasons (`POST /v1/contextual-safety/flags` stores a free `reasonCode`; the codes the platform itself raises are these).
 */
export const PERSON_RECORD_VOCABULARIES = [
    vocabulary('account.registration_channel', 'Admin person record: AccountRegistration.channel', {
        ADMIN: L('Cadastrado por um operador', 'Registered by an operator', 'Registrado por un operador', 'Registrato da un operatore'),
    }),
    vocabulary('relationships.person_kind', '@vello/api-client PersonRelationshipKind', {
        FAVORITE: L('Favorito', 'Favorite', 'Favorito', 'Preferito'),
        BLOCK: L('Bloqueio', 'Block', 'Bloqueo', 'Blocco'),
    }),
    vocabulary('relationships.person_direction', '@vello/api-client PersonRelationshipDirection', {
        BY_PERSON: L('Marcados pela pessoa', 'Set by the person', 'Marcados por la persona', 'Impostati dalla persona'),
        OF_PERSON: L('Marcaram a pessoa', 'Set on the person', 'Marcaron a la persona', 'Impostati sulla persona'),
    }),
    vocabulary('safety.incident_role', 'Admin person record: a safety incident row, the person’s role in it', {
        REPORTER: L('Quem relatou', 'Reported it', 'Quien lo reportó', 'Ha segnalato'),
        SUBJECT: L('Foi o alvo', 'Was the subject', 'Fue el sujeto', 'È stato il soggetto'),
    }),
    vocabulary('safety.flag_reason', '@vello/contextual-safety evaluateTriggers reason codes', {
        ROUTE_DEVIATION: L('Desvio de rota', 'Route deviation', 'Desvío de ruta', 'Deviazione dal percorso'),
        PROLONGED_STOP: L('Parada prolongada', 'Prolonged stop', 'Parada prolongada', 'Sosta prolungata'),
        NIGHT_ISOLATED_STOP: L('Parada isolada à noite', 'Isolated stop at night', 'Parada aislada de noche', 'Sosta isolata di notte'),
        PANIC_PRESSED: L('Botão de pânico acionado', 'Panic button pressed', 'Botón de pánico accionado', 'Pulsante di panico premuto'),
    }),
];
//# sourceMappingURL=person-record.js.map